let index = 0

export function uniqueId() {
  return `vbzc-field-${++index}`
}
